module.exports = __webpack_public_path__ + "static/media/d18ru.82510d0a.pdf";